export const GET_CASH_RECEIPT_TRANSACTIONS = 'GET_CASH_RECEIPT_TRANSACTIONS';
export const CASH_RECEIPT_TRANSACTION_REQUEST = 'CASH_RECEIPT_TRANSACTION_REQUEST';
export const CASH_RECEIPT_TRANSACTION_REQUEST_FAILURE = 'CASH_RECEIPT_TRANSACTION_REQUEST_FAILURE';